import { useMemo } from 'react';

import { Slide } from '@/api/cms';
import { filterByGroups } from '@/helpers/cms';
import { useServer } from '@/modules/server/context/ServerEnvContext';
import { useCommonStore } from '@/store';

export const useCMSSlider = () => {
  const user = useCommonStore.use.user();
  const { slides: data } = useServer();

  const slides = useMemo(() => {
    if (!data.length) return [];
    // TODO: optimize logic to avoid client-side filterByGroups
    return filterByGroups({ user })(data) as Slide[];
  }, [data, user]);

  return { slides };
};
